import { TextareaHTMLAttributes } from 'react'
import { useFormContext } from 'react-hook-form'

import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { FormValues } from '../../schema'

type FormInputProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
	name: keyof FormValues
	error?: string
	required?: boolean
}

export const FormTextareaInput = ({ name, error, className, ...rest }: FormInputProps) => {
	const { register } = useFormContext<FormValues>()

	return (
		<label className={cn('flex flex-col gap-8')}>
			<textarea
				{...rest}
				{...register(name)}
				rows={7}
				className={cn(
					'w-full resize-none rounded-8 border border-userData-textMobile bg-userData-bgSecondary p-16 md:border-userData-text md:bg-userData-bg',
					error && '!border-danger ',
					className
				)}
			></textarea>
			<div className={cn('h-12 text-danger')}>
				{error && (
					<Typography style={'p-s-bold'} element="p">
						{translate(error)}
					</Typography>
				)}
			</div>
		</label>
	)
}
